export const appService = {
    getAppVersion,
};

function getAppVersion() {
    const requestOptions = {
        method: 'GET',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
    };

    return fetch(`/signature.json?${Date.now()}`, requestOptions).then(response => response.json());
}
